export const EXAMINATION_TYPE = [
  { id: 0, label: 'All' },
  { id: 1, label: 'Pre Assessment' },
  { id: 2, label: 'Post Assessment' },
  { id: 3, label: 'Exam 1' },
  { id: 4, label: 'Exam 2' },
  { id: 5, label: 'Exam 3' },
  { id: 6, label: 'Exam 4' },
  { id: 7, label: 'Exam 5' },
  { id: 8, label: 'Exam 6' },
  { id: 9, label: 'Exam 7' },
  { id: 10, label: 'Exam 8' },
];
